import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { brandValidation } from './validation'

export const useBrandForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(brandValidation()),
    initialValues: {
      name: '',
      slug: '',
      country_id: null,
      website: '',
      description: '',
      active: 'true',
      priority: 99,
      is_import: false,
      is_partnered: false,
      featured: false,
      principal_brand: false,
      open_distributor_country: [],
      user_id: null,
      main_supplier_id: null,
      sub_supplier_id: [],
      export_minimum_value: 0,
      export_currency: '',
    },
    transformValues: (values) => {
      const suppliers = [
        ...(values.main_supplier_id
          ? [{
            supplier_id: values.main_supplier_id,
            is_primary: true
          }]
          : []
        ),
        ...values.sub_supplier_id.map(e => {
          return {
            supplier_id: e,
            is_primary: false,
          }
        })
      ]

      return {
        name: values.name,
        slug: values.slug,
        country_id: Number(values.country_id),
        website: values.website,
        description: values.description,
        active: values.active === 'true',
        priority: Number(values.priority),
        is_import: Boolean(values.is_import),
        is_partnered: Boolean(values.is_partnered),
        featured: Boolean(values.featured),
        principal_brand: Boolean(values.principal_brand),
        open_distributor_country: values.principal_brand ? [...values.open_distributor_country.map(e => e)] : [],
        user_id: values.user_id ? Number(values.user_id) : null,
        suppliers: suppliers,
        export_minimum_value: Number(values.export_minimum_value),
        export_currency: values.export_currency ? values.export_currency.toUpperCase() : '',
      }
    }
  })
}